// extracted by mini-css-extract-plugin
module.exports = {"trigger":"zone_trigger__mxPoc"};